import { nextTick, watch } from 'vue'
import { clearAllBodyScrollLocks, disableBodyScroll } from '../util/bodyScrollLock'

export default (target, trigger) => {
  watch(trigger, async (value) => {
    await nextTick()

    if (!value) {
      return clearAllBodyScrollLocks()
    }

    if (Array.isArray(target)) {
      target.forEach(disableBodyScroll)
    } else {
      disableBodyScroll(target)
    }
  })
}
